import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import {
    ApplyPodSubscriptionsApiResultModel,
    applyPodSubscriptionsService,
} from "@WhiteCap/Store/Service/OsnSubscriptionsServices/PodSubscribersService";

export interface ApplyPodSubscriptionsApiParameter extends ApiParameter {
    customerId: string;
    subscribedEmails: SubscribedEmailDto[];
    frequency: string;
    onError?: (error: string) => void;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandler<ApplyPodSubscriptionsApiParameter, ApplyPodSubscriptionsApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/PodSubscriptions/BeginApplyPodSubscriptions",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await applyPodSubscriptionsService(
        props.apiParameter.customerId,
        props.apiParameter.subscribedEmails,
        props.apiParameter.frequency,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess();
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/PodSubscriptions/ApplyPodSubscriptionsError",
        });
        return false;
    }
};

export const DispatchCompleteApplyPodSubscriptions: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/PodSubscriptions/CompleteApplyPodSubscriptions",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteApplyPodSubscriptions];

const applyPodSubscriptions = createHandlerChainRunner(chain, "ApplyPodSubscriptions");
export default applyPodSubscriptions;
